import React from "react";
import { Card, CardBody, Nav } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import store from "@pages/Statistics/store";

import { StatisticsContext } from "@pages/Statistics/context";

import { useResource } from "@hooks/useResource";

import {
    getAdvancedPeriodStringParam,
    getTypeParam,
    getSalesModesQueryString,
    getUntranslatedString,
    getFormattedCategoriesByPeriod,
    getStatisticsData,
} from "@helpers/general";

import CustomErrorBoundary from "@components/Common/CustomErrorBoundary";
import ErrorPage from "@components/Common/ErrorPage";

import DropdownWrapper from "@pages/Statistics/DropdownWrapper";
import SmoothCurveLine from "@pages/Statistics/CommonCharts/SmoothCurveLine";

export default function StatisticsServicesCol() {
    const { t } = useTranslation();
    const {
        period,
        type,
        advancedDate,
        selections,
        setHistogramData,
        setCategoriesData,
    } = React.useContext(StatisticsContext);

    const statisticsStore = useSnapshot(store);

    const [servicesData, setServicesData] = React.useState<SeriesDataType[]>(
        []
    );
    const [categories, setCategories] = React.useState<string[]>([]);

    const {
        resourceData: statisticsServicesData,
        error: statisticsServicesDataError,
    } = useResource(
        `${
            process.env.REACT_APP_API_V1_URL
        }/statistics/sales-mode/service?type=${getTypeParam(
            type
        )}&${getAdvancedPeriodStringParam(period, advancedDate)}${
            selections.designation && selections.designation !== "my_favorites"
                ? `&selected=${selections.designation}`
                : ""
        }${
            getSalesModesQueryString(statisticsStore.salesModeCards.modes)
                .length > 0
                ? `&sales-mode=${getSalesModesQueryString(
                      statisticsStore.salesModeCards.modes.map(
                          getUntranslatedString
                      )
                  )}`
                : ""
        }`
    );

    React.useEffect(() => {
        setCategories(getFormattedCategoriesByPeriod(period, advancedDate));
        setCategoriesData!(
            getFormattedCategoriesByPeriod(period, advancedDate)
        );
    }, [period, advancedDate, setCategoriesData]);

    React.useEffect(() => {
        setHistogramData!(statisticsServicesData.data);
        setServicesData(
            getStatisticsData(
                statisticsServicesData.data,
                categories,
                period,
                advancedDate
            )
        );
    }, [
        statisticsServicesData,
        categories,
        period,
        advancedDate,
        setHistogramData,
    ]);

    const servicestModes: string[] = [
        t("Midday service"),
        t("Evening service"),
    ];

    return (
        <Card>
            <CardBody className="card-body__clz">
                <Nav pills className="navtab-bg nav__clz d-none">
                    <DropdownWrapper
                        options={[
                            `${t("All")} ${t("Services")}`,
                            ...servicestModes,
                        ]}
                    />
                    <Link
                        style={{ paddingTop: "8px" }}
                        to="/turnover-detail"
                        className="btn btn-outline-dark cards btn-sm float-right d-none"
                    >
                        {t("See more")}{" "}
                        <i className="mdi mdi-arrow-right ml-1"></i>
                    </Link>
                </Nav>
                <div className="apex-charts">
                    {statisticsServicesDataError ? (
                        <ErrorPage />
                    ) : (
                        <CustomErrorBoundary>
                            <SmoothCurveLine
                                series={servicesData}
                                categories={categories}
                            />
                        </CustomErrorBoundary>
                    )}
                </div>
            </CardBody>
        </Card>
    );
}
